// Staff session token for kitchen/admin-only endpoints (orders read/update).
// Issued server-side at sign-in and short-lived — the old REACT_APP_STAFF_KEY was
// a build-time constant baked into the public bundle, so it secured nothing.
// Sent as a query param so it never triggers a CORS preflight (these are simple
// GETs). Guest endpoints (create order, payment) never send it.
import { getStaffToken } from './menuApi';

export const STRIPE_PUBLISHABLE_KEY = 'pk_live_51TNCkeB7pDx5inyvLSAYYAQirABgyunBmpwovP3E9NA8KbXgS4xRxKpwVmrUppqKg0iujsf33FznxV1FyzD3M9li00XV40wyXn';

const API_URL = 'https://z51smv2b7g.execute-api.ap-southeast-2.amazonaws.com/prod';

export const createOrder = async (orderData) => {
  const response = await fetch(`${API_URL}/orders`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(orderData),
  });
  return response.json();
};

export const getOrders = async (hotelId, status) => {
  let url = `${API_URL}/orders`;
  const params = new URLSearchParams();
  if (hotelId) params.append('hotelId', hotelId);
  if (status) params.append('status', status);
  const token = getStaffToken();
  if (token) params.append('staffToken', token);
  if (params.toString()) url += '?' + params.toString();
  const response = await fetch(url);
  return response.json();
};

// Accepts either a status string — updateOrder(id, 'preparing') — or a patch
// object — updateOrder(id, { status: 'rejected', rejectReason: '...' }). Either
// way `status` is sent as a plain string field (plus any extra fields), so the
// kitchen "start preparing / ready / reject" actions persist correctly.
export const updateOrder = async (orderId, statusOrPatch) => {
  const patch = typeof statusOrPatch === 'string'
    ? { status: statusOrPatch }
    : (statusOrPatch || {});
  const token = getStaffToken();
  const url = token
    ? `${API_URL}/orders?staffToken=${encodeURIComponent(token)}`
    : `${API_URL}/orders`;
  const response = await fetch(url, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ orderId, ...patch }),
  });
  return response.json();
};

export const createPaymentIntent = async ({ amount, hotelId, roomNumber, restaurantId, customerEmail, items, guestName, guestPhone, notes }) => {
  const response = await fetch(`${API_URL}/payment-intent`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      amount,
      hotelId,
      roomNumber,
      ...(restaurantId && { restaurantId }),
      description: 'GapGo Hotel Order - Room ' + roomNumber,
      ...(customerEmail && { customerEmail }),
      ...(items && items.length && { items }),
      ...(guestName && { guestName }),
      ...(guestPhone && { guestPhone }),
      ...(notes && { notes }),
    }),
  });
  return response.json();
};

export const logQRScan = async ({ hotelId, roomNumber, userAgent, screen, url }) => {
  try {
    await fetch(`${API_URL}/qr-scan`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        hotelId,
        roomNumber,
        userAgent: userAgent || '',
        screen: screen || null,
        url: url || '',
        scannedAt: new Date().toISOString(),
      }),
    });
  } catch (e) {
    // Silently fail — the guest flow must not break if tracking is unavailable.
  }
};

export const getQRScans = async (hotelId, limit = 200) => {
  let url = `${API_URL}/qr-scan`;
  const params = new URLSearchParams();
  if (hotelId) params.append('hotelId', hotelId);
  if (limit) params.append('limit', String(limit));
  if (params.toString()) url += '?' + params.toString();
  const response = await fetch(url);
  return response.json();
};